// @flow strict
import * as React from 'react';
import { uuid } from '@ta/common.string';

const useSessionState = () => {
  const [sessionTracking, setSessionTracking] = React.useState({
    sessionUuid: uuid(),
    sessionOrder: 0,
  });
  return React.useMemo(() => {
    const incrementOrder = () =>
      setSessionTracking(prevSession => ({
        sessionUuid: prevSession.sessionUuid,
        sessionOrder: prevSession.sessionOrder + 1,
      }));

    const resetSession = () =>
      setSessionTracking({
        sessionUuid: uuid(),
        sessionOrder: 0,
      });
    return {
      sessionUuid: sessionTracking.sessionUuid,
      sessionOrder: sessionTracking.sessionOrder,
      incrementOrder,
      resetSession,
    };
  }, [sessionTracking]);
};

export default useSessionState;
